import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { Sparkles, Check, X, Loader2 } from "lucide-react";

/* Estado do resumo em áudio por IA: a gerar → ouvir → juntar ao envio ou descartar. */
export default function AiAudioBox({ conv, ai, onDone }) {
  const act = async (action) => {
    try {
      await api.post(`/convocations/${conv.id}/study/ai-audio/${action}`);
      toast.success(action === "approve" ? "Áudio junto ao estudo prévio" : "Áudio descartado");
      onDone();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="border border-[#E50000]/40 bg-[#E50000]/5 p-4 space-y-3" data-testid="ai-audio-box">
      <div className="kw-overline text-[#E50000] flex items-center gap-2">
        <Sparkles className="w-3 h-3" /> Resumo em áudio por IA
      </div>
      {ai.status === "running" && (
        <p className="text-sm text-[#A3A3A3] flex items-center gap-2" data-testid="ai-audio-running">
          <Loader2 className="w-4 h-4 animate-spin" /> A escrever o guião e a gravar a narração (1 a 3 minutos)…
        </p>
      )}
      {ai.status === "error" && (
        <div className="flex items-center gap-3">
          <p className="text-sm text-[#E50000] flex-1" data-testid="ai-audio-error">{ai.error}</p>
          <button onClick={() => act("discard")} className="text-[10px] uppercase tracking-widest font-bold text-[#A3A3A3] hover:text-white"
            data-testid="ai-audio-dismiss">Fechar</button>
        </div>
      )}
      {ai.status === "ready" && (
        <>
          <div className="text-xs text-[#A3A3A3]">{ai.filename} · cerca de {Math.round((ai.words || 0) / 150)} min</div>
          <audio controls preload="metadata" src={`${process.env.REACT_APP_BACKEND_URL}/api/files/${ai.token}`}
            className="w-full" data-testid="ai-audio-player" />
          <div className="flex flex-wrap gap-2">
            <button onClick={() => act("approve")} className="kw-btn-primary !py-2 text-[10px] inline-flex items-center gap-1.5"
              data-testid="ai-audio-approve"><Check className="w-3 h-3" /> Juntar ao envio</button>
            <button onClick={() => act("discard")} className="kw-btn-secondary !py-2 text-[10px] inline-flex items-center gap-1.5"
              data-testid="ai-audio-discard"><X className="w-3 h-3" /> Descartar</button>
          </div>
        </>
      )}
    </div>
  );
}
